export default "__VITE_ASSET__76529364__"